import { useState } from "react";
import SectionTitle from "./common/SectionTitle";

const Contact = () => {
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		phone: "",
		subject: "",
		message: "",
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// Form submission logic here
		console.log("Form submitted:", formData);
		alert("Thank you for your message. We will contact you soon!");
		setFormData({
			name: "",
			email: "",
			phone: "",
			subject: "",
			message: "",
		});
	};

	return (
		<section className="contact">
			<div className="container">
				<SectionTitle
					title="Contact Us"
					subtitle="Get in touch with our team"
				/>

				<div className="contact-content">
					<div className="contact-info">
						<div className="info-item">
							<i className="fas fa-map-marker-alt"></i>
							<div>
								<h3>Headquarters</h3>
								<p>44 Fez Street Kumasi Crescent Wuse II Abuja FCT</p>
							</div>
						</div>
						<div className="info-item">
							<i className="fas fa-phone-alt"></i>
							<div>
								<h3>Phone</h3>
								<p>+234 803 072 4271</p>
							</div>
						</div>
						<div className="info-item">
							<i className="fas fa-envelope"></i>
							<div>
								<h3>Email</h3>
								<p>info@trivnet.ng</p>
								{/* <p>support@trivnet.ng</p> */}
							</div>
						</div>
						<div className="info-item">
							<i className="fas fa-clock"></i>
							<div>
								<h3>Working Hours</h3>
								<p>Monday - Friday: 9:00 - 18:00</p>
								{/* <p>Saturday: 10:00 - 15:00</p> */}
							</div>
						</div>
					</div>

					<div className="contact-form">
						<form onSubmit={handleSubmit}>
							<div className="form-group">
								<input
									type="text"
									name="name"
									placeholder="Your Name"
									value={formData.name}
									onChange={handleChange}
									required
								/>
							</div>
							<div className="form-group">
								<input
									type="email"
									name="email"
									placeholder="Your Email"
									value={formData.email}
									onChange={handleChange}
									required
								/>
							</div>
							<div className="form-group">
								<input
									type="tel"
									name="phone"
									placeholder="Your Phone"
									value={formData.phone}
									onChange={handleChange}
								/>
							</div>
							<div className="form-group">
								<input
									type="text"
									name="subject"
									placeholder="Subject"
									value={formData.subject}
									onChange={handleChange}
									required
								/>
							</div>
							<div className="form-group">
								<textarea
									name="message"
									placeholder="Your Message"
									value={formData.message}
									onChange={handleChange}
									required
								></textarea>
							</div>
							<button type="submit" className="submit-button">
								Send Message
							</button>
						</form>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
